module.exports = __webpack_public_path__ + "static/media/no-data.202cc663.jpg";